import { CheckCircleOutlined } from '@ant-design/icons';
import { Badge, Col, Row, Tooltip, Typography } from 'antd';
import classNames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ClockIcon } from '../../../../../assets/icons';
import styles from './ScenarioNavItem.module.css';

export default function ScenarioNavItem({ data, larName, isActive, onClick }) {
  const role = useSelector((s) => s.user.userData?.role);
  const isLender = /lender/i.test(role);
  const status = data?.bid_status ? data.bid_status?.name : data?.status;

  return (
    <div className={classNames(styles.root, { [styles.active]: isActive })} onClick={onClick}>
      <div className={styles.header}>
        <Typography.Title className={styles.title} level={5}>
          #{data?.id}, {data?.scenario?.name || larName}
        </Typography.Title>
      </div>
      <Row justify="space-between" gutter={10}>
        <Col>
          {data?.scenario?.broker_full_name ? (
            <Typography.Text>{data?.scenario?.broker_full_name}</Typography.Text>
          ) : (
            <Typography.Text>Lender {data?.number}</Typography.Text>
          )}
        </Col>
      </Row>
      <Row align="middle" gutter={10} className={styles.footer}>
        <Col span={10}>Status:</Col>
        <Col>
          {!isLender ? (
            <Row justify="space-between" align="middle" gutter={10}>
              <Col>
                <Tooltip
                  title={
                    status === 'Quote Requested' &&
                    data.quote_provided_date &&
                    moment(data.quote_provided_date).format('D MMM YYYY')
                  }
                >
                  <Typography.Text>{status}</Typography.Text>
                </Tooltip>
              </Col>
            </Row>
          ) : (
            <>
              {!data.updated_at ? (
                <div className={styles.stack}>
                  Not Quoted <ClockIcon />
                </div>
              ) : (
                <div className={styles.stack}>
                  Quoted <CheckCircleOutlined className={styles.icon} />
                </div>
              )}
            </>
          )}
        </Col>
      </Row>
      <Row align="middle" gutter={10}>
        <Col span={10}>Messages:</Col>
        <Col>
          <Badge dot offset={[11, 11]} color={data?.scenario?.new_messages || data?.new_messages ? 'red' : 'green'}>
            {data?.scenario?.new_messages || data?.new_messages ? 'Unread' : 'Up to Date'}
          </Badge>
        </Col>
      </Row>
    </div>
  );
}

ScenarioNavItem.propTypes = {
  isActive: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  larName: PropTypes.string,
  onClick: PropTypes.func,
};
